export const ADD_TAG    = 'ADD_TAG';
export const REMOVE_TAG = 'REMOVE_TAG';
export const SET_TAGS   = 'SET_TAGS';
export const UPDATE_TAG = 'UPDATE_TAG';
